import { lazy, Suspense } from 'react';

import {
  NETWORK_FEED_TYPE,
  GROUP_FEED_TYPE,
  MY_GROUPS_FEED_TYPE,
} from '../constants/FeedType';

const NetworkSideWidgets = lazy(
  () =>
    import('hb-react/frontoffice/apps/LiveFeed/containers/NetworkSideWidgets'),
);

const getFeedRights = (type, params = {}) => {
  switch (type) {
    case MY_GROUPS_FEED_TYPE: {
      return null;
    }
    case GROUP_FEED_TYPE: {
      return params.sidebar;
    }
    case NETWORK_FEED_TYPE:
    default: {
      return (
        <Suspense fallback={null}>
          <NetworkSideWidgets />
        </Suspense>
      );
    }
  }
};

export default getFeedRights;
